import { Box, Button, ImageList, Stack, Typography } from "@mui/material"
import { useSelector } from "react-redux"
import { RootState } from "../../../app/store"
import { AddAPhoto, Collections } from "@mui/icons-material"
import { useAppDispatch } from "../../../app/hooks"
import { removeRaffleImgThunk, showDialogAddImageAct } from "../handle-raffle.slice"
import DialogAddRaffleImg from "./dialog-add-image-raffle"
import ImgItemHandler from "../../../app/components/img-item-handler"
import { useState } from "react"
import DialgoSureDeleteImg from "./dialog-sure-delete-image"

export default function RaffleImagesHandler({ embedded = false }: { embedded?: boolean }) {
  const dispatch = useAppDispatch()
  const [imgToDelete, setImgToDelete] = useState<string>("")
  const { currentRaffle } = useSelector((state: RootState) => state.raffle)
  const urlApi = import.meta.env.VITE_API_URL_UPLOADS

  const deleteImg = () => {
    if (imgToDelete !== "") {
      dispatch(removeRaffleImgThunk({ raffleId: currentRaffle?._id!, img: imgToDelete }))
      setImgToDelete("")
    }
  }

  if (currentRaffle === undefined) return null

  const imageCount = currentRaffle.images?.length ?? 0

  return (
    <>
      <DialogAddRaffleImg />
      <DialgoSureDeleteImg
        show={imgToDelete !== ""}
        onCancel={() => setImgToDelete("")}
        onConfirm={deleteImg}
      />

      <Stack spacing={2}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Box>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Collections color="primary" fontSize="small" />
              <Typography variant="subtitle1" fontWeight={600}>
                Galería del sorteo
              </Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              Sube fotos atractivas del premio principal. {imageCount > 0 ? `${imageCount} imagen${imageCount !== 1 ? "es" : ""} cargada${imageCount !== 1 ? "s" : ""}.` : "Aún no hay imágenes."}
            </Typography>
          </Box>
          <Button
            variant="contained"
            size="small"
            startIcon={<AddAPhoto />}
            onClick={() => dispatch(showDialogAddImageAct(true))}
            sx={{ cursor: "pointer", whiteSpace: "nowrap", alignSelf: { xs: "stretch", sm: "auto" } }}
          >
            Agregar imágenes
          </Button>
        </Box>

        {imageCount === 0 ? (
          <Box
            sx={{
              border: "2px dashed",
              borderColor: "divider",
              borderRadius: 2,
              py: 5,
              px: 2,
              textAlign: "center",
              bgcolor: embedded ? "action.hover" : "transparent",
            }}
          >
            <Collections sx={{ fontSize: 40, color: "text.disabled", mb: 1 }} />
            <Typography variant="body2" color="text.secondary">
              Las imágenes ayudan a tus clientes a visualizar el sorteo.
            </Typography>
            <Button
              size="small"
              sx={{ mt: 1.5, cursor: "pointer" }}
              onClick={() => dispatch(showDialogAddImageAct(true))}
            >
              Subir primera imagen
            </Button>
          </Box>
        ) : (
          <ImageList cols={embedded ? 3 : 3} rowHeight={140} gap={8} sx={{ m: 0 }}>
            {currentRaffle.images.map((el) => (
              <ImgItemHandler
                key={el}
                onClickDelete={() => setImgToDelete(el)}
                src={`${urlApi}uploads/raffles/${el}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                srcSet={`${urlApi}uploads/raffles/${el}?w=164&h=164&fit=crop&auto=format`}
              />
            ))}
          </ImageList>
        )}
      </Stack>
    </>
  )
}
